import(/* webpackMode: "eager" */ "/vercel/path0/src/app/cloud-solutions/azure/page.tsx");
